import React, { createContext, useState, useEffect } from 'react';

export const LangContext = createContext({
  lang: 'en',
  setLang: () => {},
  toggleLanguage: () => {},
  switchToGerman: () => {},
  switchToEnglish: () => {},
  switchToSpanish: () => {},
});

export const LangProvider = ({ children }) => {

// const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const storedLang = localStorage.getItem('lang');
    const browserLang = navigator.language.split('-')[0];
    const supportedLangs = ['en', 'de', 'es'];

    const initialLang = supportedLangs.includes(storedLang)
      ? storedLang
      : supportedLangs.includes(browserLang)
        ? browserLang
        : 'en';

    setLang(initialLang);
  }, []);

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  const toggleLanguage = () => {
    const newLang = lang === 'de' ? 'en' : 'de';
    setLang(newLang);
  };

  const switchToGerman = () => setLang('de');
  const switchToEnglish = () => setLang('en');
  const switchToSpanish = () => setLang('es');

  return (
    <LangContext.Provider
      value={{
        lang,
        setLang,
        toggleLanguage,
        switchToGerman,
        switchToEnglish,
        switchToSpanish,
      }}
    >
      {children}
    </LangContext.Provider>
  );
};

// export default LangProvider;

